// extracted by mini-css-extract-plugin
module.exports = {"bannerWrapper":"PlayerStatsAnimationContext_bannerWrapper__1csCJ"};